package com.esoris.kmpmoout.app.supabase

import io.github.jan.supabase.createSupabaseClient
import io.github.jan.supabase.auth.Auth
import io.github.jan.supabase.postgrest.Postgrest

object SupabaseFactory {

    val client = createSupabaseClient(
        supabaseUrl = "https://qlhjejkxzzsmlwzbudyy.supabase.co",
        supabaseKey = "sb_publishable_fOdyPzIsZlPrsQd9aWcFRA_0yZJc6MR"
    ) {
        install(Postgrest)
        install(Auth)
    }
}